import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import LenisProvider from "./components/LenisProvider";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Show from "./pages/Show";
import Watch from "./pages/Watch";
import Cast from "./pages/Cast";
import Sketches from "./pages/Sketches";
import Bts from "./pages/Bts";
import Industry from "./pages/Industry";
import Join from "./pages/Join";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Accessibility from "./pages/Accessibility";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0A0A0E]" />;
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <LenisProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="grain min-h-screen bg-[#0A0A0E] text-white">
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/show" element={<Show />} />
                  <Route path="/watch" element={<Watch />} />
                  <Route path="/cast" element={<Cast />} />
                  <Route path="/sketches" element={<Sketches />} />
                  <Route path="/bts" element={<Bts />} />
                  <Route path="/industry" element={<Industry />} />
                  <Route path="/join" element={<Join />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/accessibility" element={<Accessibility />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </div>
            <Toaster theme="dark" />
          </BrowserRouter>
        </LenisProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
